import PhoneIcon from '@mui/icons-material/Phone'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { MUserInfo } from '@Models/common.model'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { MInspector } from '@Models/client/inspection.model'
import clsx from 'clsx'

interface IUserInfoBox {
    selected?: boolean
    user?: MUserInfo | MInspector
    onClick?: any
    className?: string
    remove?: boolean
    removeAction?: (e?: any) => void
}

const UserInfoBox = (props: IUserInfoBox) => {
    const { selected, user, onClick, className, remove, removeAction } = props

    return (
        <div
            className={clsx(
                'page-name-desc-box page-white-card py-2 px-4 user-info-box',
                className
            )}
            onClick={onClick}
        >
            <div className="d-flex justify-content-between page-border-bottom pb-2 mb-2">
                <div>
                    <p className="name">{user?.name}</p>
                    <p className="phone ">
                        <PhoneIcon
                            className="phone-icon mr-1"
                            style={{ fontSize: 12 }}
                        />
                        {user?.phone}
                    </p>
                </div>
                <div className="position-relative">
                    <span
                        className={clsx(
                            selected
                                ? 'selected-user-info-box'
                                : 'deselected-user-info-box'
                        )}
                    >
                        {selected && (
                            <CheckCircleIcon className="main-text select-icon" />
                        )}
                    </span>
                    {remove && !selected && (
                        <RemoveCircleOutlineIcon
                            className="remove-action"
                            onClick={(e: any) => {
                                e.preventDefault()
                                e.stopPropagation()
                                if (removeAction) removeAction(e)
                            }}
                        />
                    )}
                </div>
            </div>
            <ul className="description">
                <li>{user?.address}</li>
                <li>Distance {user?.distance} miles</li>
                <li>ID {user?.id}</li>
            </ul>
            <div className="website-link mt-2">{user?.email}</div>
        </div>
    )
}

export default UserInfoBox
